import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function SiteFooter() {
  const ref = useScrollReveal();
  const year = new Date().getFullYear();

  return (
    <footer
      ref={ref as React.RefObject<HTMLElement>}
      className="reveal relative z-10 px-6 py-10 border-t"
      style={{ borderColor: 'rgba(255,255,255,0.06)' }}
    >
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-4">
        {/* Personal intro */}
        <p
          className="font-display font-semibold text-sm tracking-[0.18em] uppercase text-white/50"
        >
          Mihajlo Radic
        </p>

        {/* Copyright */}
        <p
          className="text-xs text-white/20"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          &copy; {year} KimiCodes. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
